import { fetchApi } from '@/config/axiosSetting';

export const viewEducationFunction = (data: { id: number }) => {
  return fetchApi.post('/education/view/', data);
};
